
import AppCustomLangSelect from "@/components/CustomLanguageSelect.vue";
import AppStyleEditor from "@/components/layout-editor/StyleEditor.vue";
import AppFieldEdit from "@/components/sale-layout-editor/FieldWithSeperateStylesEdit.vue";
import { TextStyledProperty } from "@/utils/documents/text-styled-property";
import { PropSelectGroup } from "@/utils/prop-select/prop-select-group";
import { getSaleMapPropSelectGroup } from "@/utils/prop-select/sale-map-prop-group";
import Vue from "vue";
import { FieldWithSeperateStyles } from "../../utils/documents/field-with-seperate-styles";

export default Vue.extend({
	data() {
		return{
			selectedLang: "",
			toEditStyleProp: null as null | FieldWithSeperateStyles,
			toEditProp: null as null | FieldWithSeperateStyles,
		};
	},
	props: {
		line: Array as () => FieldWithSeperateStyles[],
		title: String,
		newItemConstructor: Function
	},
	computed: {
		saleMapPropSelectGroup():PropSelectGroup{
			return getSaleMapPropSelectGroup();
		}
	},
	methods: {
		addItemClicked() {
			let newItem = new FieldWithSeperateStyles();
			if (this.newItemConstructor){
				newItem = this.newItemConstructor();
			}
			this.line.push(newItem);
		},
		removeItem(index: number) {
			this.line.splice(index, 1);
		},
		editStyle(style: FieldWithSeperateStyles) {
			this.toEditStyleProp = style;
		},
		setAllStyles(style:TextStyledProperty){
			if (!this.toEditStyleProp) return;
			this.toEditStyleProp.Style = new TextStyledProperty(style.getJSON());
			this.toEditStyleProp.AfterTextStyle = new TextStyledProperty(style.getJSON());
			this.toEditStyleProp.PropStyle = new TextStyledProperty(style.getJSON());
		},
		editProp(prop: FieldWithSeperateStyles) {
			this.toEditProp = prop;
		},
		getPropValue(prop: FieldWithSeperateStyles): string {
			if (!prop.Prop) return "";
			let val = this.saleMapPropSelectGroup.getPropSelectFromValue(prop.Prop);
			if (!val) return "";
			return val.text.toString();;
		}
	},
	components: {
		AppCustomLangSelect,
		AppStyleEditor,
		AppFieldEdit
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
